export default {
  lstTab: {
    System: 'Hệ Thống',
    Personal: 'Cá Nhân',
  },

  Notification: {
    RevenueBreakout: 'Doanh Thu Vượt Trội',
    ProfitBreakout: 'Lợi Nhuận Vượt Trội',
    Watchout: 'Nguy Hiểm',
    UpgradeScoring: 'Tăng Thứ Hạng',
    News: 'Tin Tức',
    TASignals: 'Tín Hiệu Kỹ Thuật',
    PromissingDividend: 'Cổ Tức',
    TAStrategy: 'Chiến Lược Kỹ Thuật',
    PriceAndVolume: 'Giá và Lượng',
    JapaneseCandlestick: 'Mô Hình Nến Nhật',
  },
  errorFormTitle: 'Không thể lưu tùy chỉnh',
  errorFormMessage: 'Để lưu tùy chỉnh, bạn cần chọn mã cổ phiếu',

  noNotification: 'Không có Thông Báo',
  fundamental: 'Cơ Bản',
  events: 'Sự Kiện',
  news: 'Tin Tức',
  technical: 'Kỹ Thuật',
  setting: 'Cài Đặt',
  tableTitle: {
    name: 'Tên',
    active: 'Kích Hoạt',
  },
  alertCode: {
    All: 'Tất cả cảnh báo',
    BreakOut: 'Bứt phá KQKD',
    FallDown: 'Sụt giảm KQKD',
    FinancialAssessment: 'Đánh giá Tài chính',
    Ranking: 'Xếp hạng DN',
    Technical: 'PT Kỹ thuật',
    CompanyEvents: 'Sự kiện DN',
    PriceVolume: 'PT Giá - KL',
    PersonalAlert: 'Cảnh báo Cá Nhân',
  },
};
